import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { HttpClient } from '../configs/axios.config';
import { AuthModel } from '../interfaces/models/AuthModel';
import {BootstrapModel, UserModel} from '../interfaces/models/UserModel';
import { Api } from './Api';

@injectable()
export class UserApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    socialAuth(provider, code, state): AxiosPromise<any> {
        return this.api.client.get<any>(`/auth/social/${provider}/?code=${code}&state=${state}`);
    }

    bootstrap(fields?: string[]): AxiosPromise<BootstrapModel> {
        return this.api.client.get<BootstrapModel>(`/user/bootstrap/${fields ? `?fields=${fields.join(',')}` : ''}`);
    }

    profile(): AxiosPromise<UserModel> {
        return this.api.client.get<UserModel>(`/user/current/`);
    }

    search(email: string): AxiosPromise<UserModel> {
        return this.api.client.post<UserModel>(`/user/search/`, {
            email
        });
    }

    resendConfirmation(): AxiosPromise<UserModel> {
        return this.api.client.get<UserModel>(`/auth/resendcode/`);
    }

    update(data) {
        return this.api.client.post(`/user/current/`, data);
    }

    checkEmail(email) {
        return this.api.client.post<{ result: boolean }>(`/auth/checkemail/`, { email });
    }

    authorize(email, password): AxiosPromise<AuthModel> {
        return this.api.client.post<AuthModel>(`/auth/token/`, {
            email, password
        });
    }

    register(data) {
        return this.api.client.post<AuthModel>(`/auth/signup/`, data);
    }

    reset(data: { email, code?, password_new? }) {
        return this.api.client.post<AuthModel>(`/auth/resetpassword/`, data);
    }

    setNewPassword(data) {
        return this.api.client.post<AuthModel>(`/auth/new/`, data);
    }

    setOption(key, value) {
        return this.api.client.post(`/user/option/`, { key, value });
    }

    logout() {
        return this.api.client.get(`/user/logout/`);
    }

    remove() {
        return this.api.client.get(`/user/remove/`);
    }

}
